import { styled } from "styled-system/jsx";

export const Card = styled("div", {
	base: {
		background: "white",
		borderWidth: "1px",
		borderColor: "gray.200",
		borderRadius: "lg",
		padding: "5",
		boxShadow: "sm",
	},
});
